import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tooltip-info-paper-weight',
  templateUrl: './tooltip-info-paper-weight.component.html',
  styleUrls: ['./tooltip-info-paper-weight.component.scss'],
  standalone: false
})
export class TooltipInfoPaperWeightComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
